import { render, staticRenderFns } from "./StatefulContainer.vue?vue&type=template&id=56b9f45a&scoped=true&"
import script from "./StatefulContainer.vue?vue&type=script&lang=ts&"
export * from "./StatefulContainer.vue?vue&type=script&lang=ts&"
import style0 from "./StatefulContainer.vue?vue&type=style&index=0&id=56b9f45a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b9f45a",
  null
  
)

export default component.exports